import { render, staticRenderFns } from "./FieldTypeTable.vue?vue&type=template&id=54fa231a"
import script from "./FieldTypeTable.vue?vue&type=script&lang=js"
export * from "./FieldTypeTable.vue?vue&type=script&lang=js"
import style0 from "./FieldTypeTable.vue?vue&type=style&index=0&id=54fa231a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports